import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import LoginPage from "./pages/SignIn";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { MainHeader } from "./components/layout/MainHeader";
import { useLocation } from "react-router-dom";
import { getUserRole } from "./service/api/apiClient";
import { getRoutesForRole } from "./utils/routeConfig";
import RoleGuard from "./RoleGuard";

const routeTitles = {
    "/":                   "Dashboard",
    "/dashboard":          "Dashboard",
    "/orders":             "Orders",
    "/order":              "Order Details",
    "/signin":             "Login",
    "/delivery-guys":      "Delivery Guys",
    "/shifts":             "Delivery",
    "/manager":            "Delivery",
    "/field-manager-home": "Delivery",
    "/promotions/coupons":       "Coupons",
    "/promotions/notifications": "Send Notification",
};

function TitleManager() {
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname;
        document.title = path.startsWith("/order/")
            ? routeTitles["/order"]
            : routeTitles[path] || "Dashboard";
    }, [location]);
    return null;
}

export default function App() {
    const role           = getUserRole();
    const normalizedRole = role?.toLowerCase().replace(/\s+/g, "_");
    const routes         = getRoutesForRole(normalizedRole);

    useEffect(() => {
        const unlock = () => { new Audio().play().catch(() => {}); };
        document.addEventListener("click", unlock, { once: true });
    }, []);


    return (
        <BrowserRouter>
            <TitleManager />
            <Routes>
                <Route element={<PrivateRoute />}>
                    {/* MainHeader must be a direct <Route> child of <Routes> */}
                    <Route element={<MainHeader />}>
                        {routes.map((r, i) =>
                            r.index ? (
                                <Route
                                    key={i}
                                    index
                                    element={
                                        <RoleGuard>{r.element}</RoleGuard>
                                    }
                                />
                            ) : (
                                <Route
                                    key={i}
                                    path={r.path}
                                    element={
                                        <RoleGuard>{r.element}</RoleGuard>
                                    }
                                />
                            )
                        )}

                        <Route path="*" element={<RoleGuard>{null}</RoleGuard>} />
                    </Route>
                </Route>

                <Route element={<PublicRoute />}>
                    <Route path="/signin" element={<LoginPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}